import type { DeviceType } from '@provider-portal/common/styles/useThemeHooks';
import { type ActionType, createAction } from 'typesafe-actions';

export const setDeviceType = createAction('SET_DEVICE_TYPE')<DeviceType>();

export type ThemeActions = ActionType<typeof setDeviceType>;
